import { SignalRConnection } from '@henkkelder/ng2-signalr';
import { createAction } from '@ngrx/store';
import { PortTemplates } from '../model/dcAttributeTemplate.model';
import { dcKPIData } from '../model/dcKPIs.model';
import { dcTag } from '../model/dcTag.model';
import { RoleAssignment, User } from '../model/user.model';
import { ActionableProcessHeader } from '../model/workflow/actionable-process-header.model';

enum CommonStoreActions {
  RESIZE_APP_ACTION = '[App] Resize App Trigger',
  USER_DETAILS_REQUEST_ACTION = '[User] UserDetailsRequest',
  USER_DETAILS_RESULT_ACTION = '[User] UserDetailsResult',
  USER_LOGOUT_ACTION = '[User] Logout',
  USER_PROFILE_APPS_RESULT_ACTION = '[User Profile Apps] Result',
  USER_PROFILE_SWITCH_ROLE_ACTION = '[User Profile] SwitchRole',
  USER_PROFILE_SWITCH_ROLE_RESULT_ACTION = '[User Profile] SwitchRole Result',
  //++ For KPI Bar Select Action to launch AndonBoard
  SELECTED_KPI_ACTION = '[KPI] Select',
  USER_PROFILE_SWITCH_PROFILE_TAG_ACTION = '[User Profile Tag] SwitchProfileTag',
  USER_PROFILE_TAG_CHANGED_RESULT_ACTION = '[User] UserProfileTagChanged',
  SET_SIGNALR_CONNECTION_ACTION = '[SignalR] Set connection',
  DROPDOWN_DATA_ACTION = '[Dropdown] Data',
  PORT_VISUALIZATION = '[portConnection] Data',
  ROLE_PROCESS_DESIGN = '[roleProcessDesigns] Data'
}

export const resizeAppAction = createAction(CommonStoreActions.RESIZE_APP_ACTION);

export const userDetailsRequestAction = createAction(
  CommonStoreActions.USER_DETAILS_REQUEST_ACTION
);

export const userDetailsResultAction = createAction(
  CommonStoreActions.USER_DETAILS_RESULT_ACTION,
  (userDetails: User) => ({ userDetails })
);

export const userLogoutAction = createAction(CommonStoreActions.USER_LOGOUT_ACTION);

export const userProfileAppsResultAction = createAction(
  CommonStoreActions.USER_PROFILE_APPS_RESULT_ACTION,
  (userMenuTags: dcTag[]) => ({ userMenuTags })
);

export const userProfileSwitchRoleAction = createAction(
  CommonStoreActions.USER_PROFILE_SWITCH_ROLE_ACTION,
  (roleAssignID: number, currentUserRole?: RoleAssignment, onGetUser?: boolean) => ({
    roleAssignID,
    currentUserRole,
    onGetUser
  })
);

export const userProfileSwitchRoleResultAction = createAction(
  CommonStoreActions.USER_PROFILE_SWITCH_ROLE_RESULT_ACTION,
  (roleAssignID: number, processDesignElements: ActionableProcessHeader[]) => ({
    roleAssignID,
    processDesignElements
  })
);

export const selectedKPIAction = createAction(
  CommonStoreActions.SELECTED_KPI_ACTION,
  (selectedKPI: dcKPIData) => ({ selectedKPI })
);

export const userProfileSwitchProfileTagAction = createAction(
  CommonStoreActions.USER_PROFILE_SWITCH_PROFILE_TAG_ACTION,
  (tag: dcTag) => ({ tag })
);

export const userProfileTagChangedResultAction = createAction(
  CommonStoreActions.USER_PROFILE_TAG_CHANGED_RESULT_ACTION
);

export const setSignalRConnectionAction = createAction(
  CommonStoreActions.SET_SIGNALR_CONNECTION_ACTION,
  (signalRConnection: SignalRConnection) => ({ signalRConnection })
);

export const dropdownDataAction = createAction(
  CommonStoreActions.DROPDOWN_DATA_ACTION,
  (dropdownData: any) => ({ dropdownData })
);

export const portVisualizationAction = createAction(
  CommonStoreActions.PORT_VISUALIZATION,
  (portTemplates: PortTemplates[], elemenTypeId: number) => ({ portTemplates, elemenTypeId })
);

export const roleProcessDesignsResponseAction = createAction(
  CommonStoreActions.ROLE_PROCESS_DESIGN,
  (processDesignElements: ActionableProcessHeader[]) => ({ processDesignElements })
);
